export const projects = [
  
  {
    id: 1,
    name: 'Freelancer Flow',
    description: 'A full-stack web application for managing clients, proposals, and workflow in one place.',
    technologies: ['Typescript', 'React', 'Next.js', 'Node.js', 'MongoDB', 'Tailwind CSS','Recharts', 'lucide-react', 'Stripe API', 'NextAuth'],
    links: {
      client: 'https://github.com/Sarwar009/freelancerFlow',
      live: 'https://freelancerflowbeta.vercel.app/',
    },
    features: [
      'Developed responsive frontend using Next.js and Tailwind CSS.',
      'Designed and built RESTful APIs for handling clients and proposals',
      'Implemented secure authentication system using NextAuth',
      'Integrated Stripe payment system for subscription-based billing',
      'Built a modern dashboard UI with smooth user experience',
    ],
    // challenges: [
    //   'Building efficient video streaming infrastructure',
    //   'Implementing progress synchronization across devices',
    //   'Creating assessment system with automated grading',
    //   'Optimizing performance with Next.js ISR and SSG strategies',
    // ],
    improvements: [
      'Add real-time notifications',
      'Implement custom dashboard widgets for analytics',
      'Create peer discussion forums and study groups',
      'Add mobile app for offline course content access',
    ],
  },
  
  {
    id: 2,
    name: 'ChefBazaar',
    description: 'A full-stack recipe and grocery platform with authentication, payments, and dynamic data handling.',
    technologies: ['React.js', 'Next.js', 'Node.js', 'MongoDB', 'Tailwind CSS', 'REST API', 'JWT', 'Cookies', 'Stripe'],
    links: {
      client: 'https://github.com/Sarwar009/ChefBazarClient',
      server: 'https://github.com/Sarwar009/ChefBazarServer',
      live: 'https://chef-bazar.vercel.app/',
    },
    features: [
      'Developed responsive frontend using React.js and Tailwind CSS',
      'Designed and built RESTful APIs using Node.js and Express.js',
      'Implemented JWT-based authentication and protected routes',
      'Integrated MongoDB for efficient data storage and retrieval',
      'Integrated Stripe payment system',
    ],
    // challenges: [
    //   'Building efficient video streaming infrastructure',
    //   'Implementing progress synchronization across devices',
    //   'Creating assessment system with automated grading',
    //   'Optimizing performance with Next.js ISR and SSG strategies',
    // ],
    improvements: [
      'Add interactive live classes with instructor-student Q&A',
      'Implement AI-powered personalized learning paths',
      'Create peer discussion forums and study groups',
      'Add mobile app for offline course content access',
    ],
  },
  {
    id: 3,
    name: 'Freelance Marketplace',
    description: 'A full-stack platform for freelancers and clients to connect',
    technologies: ['React', 'Node.js', 'MongoDB', 'Firebase', 'Tailwind CSS', 'lucide-react', 'React Toastify', 'Context API'],
    links: {
      client: 'https://github.com/Sarwar009/ph-B12A10-FreelanceMarlet-client',
      server: 'https://github.com/Sarwar009/ph-B12A10-FreelanceMarlet-server',
      live: 'https://freelancemarket.netlify.app/',
    },
    features: [
      'User Registration & Login',
      'Add / Manage / Update Jobs',
      'Accept Job Requests',
      'Sorting & Filtering Jobs',
      'Real-time loading & toast notifications',
    ],
    // challenges: [
    //   'Implementing secure payment processing with multiple gateway providers',
    //   'Real-time bidding system with WebSocket optimization',
    //   'Handling concurrent database transactions for bid management',
    //   'Designing scalable user rating and review system',
    // ],
    improvements: [
      'Add advanced search and filtering',
      'Implement video calling for client-freelancer meetings',
      'Create analytics dashboard for project insights',
      'Add dispute resolution system with mediation support',
    ],
  },
  {
    id: 4,
    name: 'App Store Explorer',
    description: 'A modern React app to explore, search, and filter mobile applications with category-based browsing.',
    technologies: ['React', 'React Router', 'Tailwind CSS', 'lucide-react', 'React Toastify', 'Recharts', 'Firebase', 'Context API'],
    links: {
      client: 'https://github.com/Sarwar009/ph-B12A08-App-Store',
      // server: null,
      live: 'https://ph-b12a08-app-store.vercel.app/',
    },
    features: [
      'Browse apps by category',
      'Search apps instantly with dynamic filtering',
      'Detailed app information page',
      'Responsive & smooth UI with Tailwind CSS',
      'Favorites list using local storage',
    ],
    improvements: [
      'Add backend to store real app data instead of static JSON',
      'Implement user authentication for saving favorites across devices',
      'Add app rating & review system',
      'Integrate API for trending apps and real-time updates',
    ],
  },
];
